import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components'
import { fetchAwardList, fetchBonusList } from './api'
import moment from 'moment'
import Header from '@/components/Header'
import { popNativePage } from "@/utils";
import ListView from '@/components/ListView/list-view'
import Empty from "@/components/Empty";

const AwardDetail = () => {
  const lastId = useRef('')
  const lastId2 = useRef('')
  const [list, setList] = useState([])
  const [list2, setList2] = useState([])
  const [awardTab, setAwardTab] = useState(0);
  const loadingRef = useRef(false);
  const loadAll = useRef(false);
  const listRef = useRef([]);
  listRef.current = list
  const listRef2 = useRef([]);
  listRef2.current = list2
  const loadAll2 = useRef(false);
  const awardTabRef = useRef(0)
  awardTabRef.current = awardTab;

  useEffect(() => {
    getData(0);
  }, [])

  const getData = (tab = 0) => {
    if (loadingRef.current) {
      return;
    }
    loadingRef.current = true;
    if (tab === 0) {
      fetchAwardList({ activityId: 230, lastId: lastId.current, pageSize: 20 }).then(res => {
        const data = res.data || [];
        const nextList = [...listRef.current, ...data]
        setList(nextList)

        const last = data[data.length - 1];
        if (last) {
          lastId.current = last.id
        }
        if (data.length < 20) {
          loadAll.current = true;
        }

        loadingRef.current = false;
      })
    } else {
      fetchBonusList({ activityId: 230, lastId: lastId.current, pageSize: 20 }).then(res => {
        const data = res.data || [];
        const nextList = [...listRef2.current, ...data]
        setList2(nextList)

        const last = data[data.length - 1];
        if (last) {
          lastId2.current = last.id
        }
        if (data.length < 20) {
          loadAll2.current = true;
        }

        loadingRef.current = false;
      })
    }
    
  }

  const formatDate = (date) => {
    if (!date) {
      return ''
    }
    return moment(date).format('YYYY-MM-DD HH:mm')
  }

  const getAwardName = (item) => {
    if (item.awardType === 0) {
      return `积分：+${item.awardNum}`;
    }
    if (item.awardType === 1) {
      return `${item.awardName}`;
    }
    if (item.awardType === 18) {
      if (item.parentAwardType === 17) {
        return `大红包：+${item.awardAmount}元`;
      }
      if (item.parentAwardType === 16) {
        return `+${item.awardName}`;
      }
    }
  }

  const getAwardTypeName = (item) => {
    switch(item.awardType) {
      case 0: return '积分'
      case 1: return '会员'
      case 18: {
        if (item.parentAwardType === 17) {
          return '大红包'
        }
        return '红包'
      }
      default: return ''
    }
  }

  const handleReachBottom = () => {
    if (loadAll.current) {
      return;
    }
    getData(awardTabRef.current);
  }

  const handleReachBottom2 = () => {
     if (loadAll2.current) {
      return;
    }
    getData(awardTabRef.current);
  }

  const handleAwardTab = (tab) => {
    setAwardTab(tab);
    if (tab === 0 && listRef.current.length === 0) {
      getData(tab)
    }
    if (tab === 1 && listRef2.current.length === 0) {
      getData(tab)
    }
  }

  const formatBonus = (item) => {
    const change = item.withdrawableBonusAfter - item.withdrawableBonusBefore
    return `${change > 0 ? '+' : ''}${Number(change).toFixed(2)}`
  }

  return (
    <Container>
      <Header
        title={'获得奖励明细'}
        leftClick={popNativePage}
      />
      <div className="tabs">
        <div className={`tab-item ${awardTab === 0 ? 'tab-item-active' : ''}`} onClick={() => handleAwardTab(0)}>
          <span>抽中奖励</span>
          {awardTab === 0 && <div className="tab-indicator" />}
        </div>
        <div className={`tab-item ${awardTab === 1 ? 'tab-item-active' : ''}`} onClick={() => handleAwardTab(1)}>
          <span>红包变动</span>
          {awardTab === 1 && <div className="tab-indicator" />}
        </div>
      </div>
      <div className="award-title flex-between">
        <span>{awardTab === 0 ? '奖励/时间' : '名称'}</span>
        <span>{awardTab === 0 ? '类型' : '金额'}</span>
      </div>
      {awardTab === 0 && (
        <ListView onReachBottom={handleReachBottom}>
          {list.map(item => {
            return (
              <div key={item.id} className="award-item">
                <div className="flex-between award-head">
                  <span>{getAwardName(item)}</span>
                  <span className="award-type">{getAwardTypeName(item)}</span>
                </div>
                <div className="arard-time">{formatDate(item.createTime)}</div>
              </div>
            )
          })}
        </ListView>)
      }

      {awardTab === 1 && (
        <ListView onReachBottom={handleReachBottom2}>
          {list2.map(item => {
            return (
              <div key={item.id} className="award-item">
                <div className="award-head flex-between">
                  <div>{item.reason}</div>
                  <div>{formatBonus(item)}</div>
                </div>
                <div className="arard-time">{formatDate(item.createTime)}</div>
              </div>
            )
          })}
        </ListView>)
      }
      {((awardTab === 0 && list.length === 0) || (awardTab === 1 && list2.length === 0)) && <Empty />}
    </Container>
  )
}

export default AwardDetail;

const Container = styled.div`
  background-color: #F3F4F9;
  padding-top: 44px;
  box-sizing: border-box;
  min-height: 100vh;
  .award-title {
    height: 36px;
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
    line-height: 17px;
    padding: 0 16px;
  }
  .award-item {
    height: 77px;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 16px 16px 0;
    border-bottom: 1px solid #E5E5E5;
    .award-head {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 6px;
    }
  }

  .bonus-item {
    height: 77px;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 16px 16px 0;
    border-bottom: 1px solid #E5E5E5;

    .bonus-head {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
    }
  }
  .arard-time {
    font-weight: 400;
    font-size: 12px;
    color: #9696A6;
    line-height: 17px;
  }
  .award-type {
    font-weight: 500;
    font-size: 16px;
    color: #4074FE;
    line-height: 22px;
  }

  .bonus-item {
    display: flex;
    justify-content: space-between;
  }

  .tabs {
    height: 40px;
    display: flex;
    background: #fff;
    position: sticky;
    top: 0px;
    .tab-item {
      flex: 1;
      font-weight: 400;
      font-size: 15px;
      color: #9696A6;
      line-height: 40px;
      text-align: center;
      position: relative;
    }
    .tab-indicator {
      width: 14px;
      height: 3px;
      background: #FF2848;
      border-radius: 2px;
      bottom: 0;
      left: calc(50% - 7px);
      position: absolute;
    }
    .tab-item-active {
      color: #293241;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/views/activity_230/award.js